<template>
    <div>
        <v-container class="hidden-lg-and-up">
            <v-layout column wrap align-center>
                <v-flex xs12 align-center>
                <h1> TRANSFORMAÇÃO DIGITAL </h1>
                <hr style="background-color: #073A56;width: 90px; margin-right: 0px;height: 5px"/>
                </v-flex>            
            </v-layout>
            <div v-for="item in list" :key="item.title">
                <v-layout align-center justify-center column fill-height >
                    <v-flex>
                        <v-img background-color="white" width="calc(50vw)" :src="item.image"></v-img>
                    </v-flex>
                    <v-flex xs10>                        
                        <h2 style="text-align: center"> {{item.title}} </h2>
                        <p style="text-align: justify"> {{item.description}} </p>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>
    <v-container class="hidden-md-and-down">
        <v-layout column wrap align-center>
            <v-flex xs12 align-center>
            <h1> TRANSFORMAÇÃO DIGITAL </h1>
            <hr style="background-color: #073A56;width: 90px; margin-right: 0px;height: 5px"/>
            </v-flex>            
        </v-layout>
        <v-layout row wrap align-center>
            <v-flex xs12 sm12 md5 text-md-right text-sm-right style="z-index: 1">
            <v-layout align-center justify-center row fill-height>
                <v-flex xs6 md8>
                <h2> {{list[0].title}} </h2>
                <p> {{list[0].description}} </p>
                </v-flex>
                <v-flex xs6 md4 fill-height>
                <v-img background-color="white" :src="list[0].image"></v-img>
                </v-flex>
            </v-layout>
            </v-flex>

            <v-flex class="hidden-md-and-down" xs12 md2 text-center>
            <v-img class="hidden-md-and-down" style="margin-top: 100px;margin-left: -40px; width: 278px; z-index: 0" src="static/line-left.png"></v-img>
            </v-flex>
            
            <v-flex xs12 sm12 md5 style="z-index: 1">            
            <v-layout align-center justify-center row fill-height style="margin-top: 220px; z-index:2;">
                <v-flex xs6 md4 fill-height>
                <v-img style="z-index: 1;" background-color="white" :src="list[1].image"></v-img>
                </v-flex>
                <v-flex xs6 md8>
                <h2> {{list[1].title}} </h2>
                <p> {{list[1].description}} </p>
                </v-flex>              
            </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row wrap align-center style="margin-top: -135px;">
        
            <v-img class="hidden-md-and-down" style="position: absolute;margin-left: 430px;margin-top: -65px;width: 278px; z-index: 0" src="static/line-right.png"></v-img>
        
            <v-flex xs12 sm12 md5 text-md-right text-sm-right style="z-index: 1">
            <v-layout align-center justify-center row fill-height>
                <v-flex xs6 md8>
                <h2> {{list[2].title}} </h2>
                <p> {{list[2].description}} </p>
                </v-flex>
                <v-flex xs6 md4 fill-height>
                <v-img background-color="white" :src="list[2].image"></v-img>
                </v-flex>
            </v-layout>
            </v-flex>

            <v-flex class="hidden-md-and-down" text-center>
            <v-img class="hidden-md-and-down" style="position:absolute;margin-top: -80px;margin-left: -45px; width: 278px; z-index: 0" src="static/line-left.png"></v-img>
            </v-flex>

            <v-flex xs12 sm12 md5 style="z-index: 1">
            <v-layout align-center justify-center row fill-height style="margin-top: 220px; z-index:2;">
                <v-flex xs6 md4 fill-height>
                <v-img style="z-index: 1;" background-color="white" :src="list[3].image"></v-img>
                </v-flex>
                <v-flex xs6 md8>
                <h2> {{list[3].title}} </h2>
                <p> {{list[3].description}} </p>
                </v-flex>              
            </v-layout>
            </v-flex>
        </v-layout> 

        <v-layout row wrap align-center style="margin-top: -35px;">
        
            <v-img class="hidden-md-and-down" style="position: absolute;margin-left: 430px;margin-top: -65px;width: 278px; z-index: 0" src="static/line-right.png"></v-img>
        
            <v-flex xs12 sm12 md5 text-md-right text-sm-right style="z-index: 1">
            <v-layout align-center justify-center row fill-height>
                <v-flex xs6 md8>
                <h2> {{list[4].title}} </h2>
                <p> {{list[4].description}} </p>
                </v-flex>
                <v-flex xs6 md4 fill-height>
                <v-img background-color="white" :src="list[4].image"></v-img>
                </v-flex>
            </v-layout>
            </v-flex>
        </v-layout>       
    </v-container>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        name: 'app-transformacaodigital',
        data () {
            return {
                list: [
                    {
                        title: 'G Suite',
                        description: 'Em parceria com a Ensinar Tecnologia, Implantamos e formamos profissionais na plataforma do Google.',
                        image: 'static/drive.png'
                    },
                    {
                        title: 'Infraestrutura',
                        description: 'Realizamos a migração de seus serviços para a nuvem, custamizando para um novo cenário com custo reduzido e maior garantia de disponibilidade dos serviços.',
                        image: 'static/infraestrutura.png'
                    },
                    {
                        title: 'Desenvolvimento de aplicações',
                        description: 'Criamos aplicativos ou sites com interfaces modernas e construídos com tecnologias de alta escalibidade.',
                        image: 'static/aplicacoes.png'
                    },
                    {
                        title: 'Big Data & Analytics',
                        description: 'Coletamos dados dos N-sistemas que seu negócio venha a possuir ou utilizar e então transformamos os dados em informações que geram valor e auxiliam na tomada de decisão.',
                        image: 'static/bigdata.png'
                    },
                    {
                        title: 'Inteligência Artificial',
                        description: 'Trabalhamos desde a construção de assistentes virtuais, até mesmo a construção de inteligências personalizada que aprendem com os dados da sua empresa e são capazes de realizar determinadas funções apartir do que aprenderam.',
                        image: 'static/ia.png'
                    }
                    
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TransformacaoDigital.vue